/**
 * 记录所有浏览操作历史栈
 * record history stack
 */

const routes = [];
export default routes;
